import React from "react";
import PropTypes from "prop-types";
import { default as ReactSelect } from "react-select";

const MySelect = (props) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "40px",
      height: "40px",
      border: "2px solid #f5f6f7",
      borderRadius: "0.5rem",
      transition: "border-color 0.2s ease",
      boxShadow: "none",
      backgroundColor: "#fff", // same as SearchBar bg
      "&:hover": {
        borderColor: "#d1d5db",
      },
      borderColor: state.isFocused ? "#d1d5db" : "#f5f6f7",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 0.5rem",
      color: "#000", // text color inside
    }),
    input: (provided) => ({
      ...provided,
      color: "#000", // typing text color
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000", // selected value color
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#9ca3af", // Tailwind gray-400, matches your SearchBar placeholder
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      paddingRight: "0.5rem",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "transparent",
      color: "#000000",
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999, // 👈 ensures dropdown is above everything
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // 👈 also apply to the menu itself
    }),
  };

  if (props.allowSelectAll) {
    return (
      <ReactSelect
        {...props}
        options={[props.allOption, ...props.options]}
        onChange={(selected, event) => {
          if (selected !== null && selected.length > 0) {
            if (selected[selected.length - 1].value === props.allOption.value) {
              return props.onChange([props.allOption, ...props.options]);
            }
            let result = [];
            if (selected.length === props.options.length) {
              if (selected.includes(props.allOption)) {
                result = selected.filter(
                  (option) => option.value !== props.allOption.value
                );
              } else if (event.action === "select-option") {
                result = [props.allOption, ...props.options];
              }
              return props.onChange(result);
            }
          }

          return props.onChange(selected);
        }}
      />
    );
  }

  return <ReactSelect {...props} styles={customStyles} />;
};

MySelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};

MySelect.defaultProps = {
  allOption: {
    label: "Select all",
    value: "*",
  },
};

export default MySelect;
